module.exports = __webpack_public_path__ + "img/icon-48x48.b0a3625e.png";